<template>
  <div>
    <!-- <div class="card">
      <div class="card-body text-center">
        
        <h5 class="card-title" v-html="'Ανακοινώσεις'"></h5>

        <span class="card-title" v-html="'Προθεσμία Ανάληψης για εξέταση το Εαρινό Εξάμηνο: '"></span>
        <div class="input-group mb-3" v-if="isAdmin">
          <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2">
          <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button">Αποθήκευση</button>
          </div>
        </div>
        <div class="card-title text-center" v-if="!isAdmin">
          <span class="card-title" v-html="'10-03-2021'"></span>            
        </div>

        <span class="card-title" v-html="'Προθεσμία Έγκρισης για εξέταση το Εαρινό Εξάμηνο: '"></span>
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2">
          <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button">Αποθήκευση</button>
          </div>
        </div>

        <br/>

        <span class="card-title" v-html="'Προθεσμία Ανάληψης για εξέταση το Χειμερινό εξάμηνο: '"></span>
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2">
          <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button">Αποθήκευση</button>
          </div>
        </div>

        <span class="card-title" v-html="'Προθεσμία Έγκρισης για εξέταση το Εαρινό Εξάμηνο: '"></span>
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2">
          <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button">Αποθήκευση</button>
          </div>
        </div>

        <br />

      </div>
    </div> -->

    <div class="card">
      <div class="card-body text-center">
        <!-- <h3 class="card-title" v-html="Translate('@_WELCOME_SIMPLE')"></h3> -->
        <p class="card-title" v-html="Translate('@_DATE_LINE1_TEXT')"></p>
        <h5 class="card-title" v-html="Translate('@_DATE_LINE1').substr(8, 2)+'-'+Translate('@_DATE_LINE1').substr(5, 2)+'-'+Translate('@_DATE_LINE1').substr(0, 4)"></h5>
        
        <br />
        <router-link class="btn btn-outline-dark" v-bind:to="{ name: 'theses' }">
          <span v-html="Translate('@_GRADUATE_THESIS_LIST')"></span>
        </router-link>
        <br />
        <br />
        <router-link
          class="btn btn-outline-dark"
          v-bind:to="{ name: 'thesis_new' }"
          v-html="Translate('@_CREATE')"
          v-if="isProfessor || isAdmin"
        ></router-link>
      </div>
    </div>

    <div class="card">
      <div class="card-body text-center">
        <h5 class="card-title" v-html="'Χρήσιμα Αρχεία'"></h5>

        <br />
        <a
          href="https://www.iee.ihu.gr/support/%ce%ad%ce%bd%cf%84%cf%85%cf%80%ce%b1-%cf%85%cf%80%ce%b7%cf%81%ce%b5%cf%83%ce%af%ce%b5%cf%82-%ce%b3%cf%81%ce%b1%ce%bc%ce%bc%ce%b1%cf%84%ce%b5%ce%af%ce%b1%cf%82/%cf%87%cf%81%ce%ae%cf%83%ce%b9%ce%bc%ce%b1-%ce%ad%ce%bd%cf%84%cf%85%cf%80%ce%b1-%ce%b3%ce%b9%ce%b1-%cf%86%ce%bf%ce%b9%cf%84%ce%b7%cf%84%ce%ad%cf%82/"
          target="_blank"
        >Κανονισμός Πτυχιακών/Διπλωματικών</a>
        <br />
        <br />
        <a
  href="https://www.iee.ihu.gr/support/%ce%ad%ce%bd%cf%84%cf%85%cf%80%ce%b1-%cf%85%cf%80%ce%b7%cf%81%ce%b5%cf%83%ce%af%ce%b5%cf%82-%ce%b3%cf%81%ce%b1%ce%bc%ce%bc%ce%b1%cf%84%ce%b5%ce%af%ce%b1%cf%82/%cf%87%cf%81%ce%ae%cf%83%ce%b9%ce%bc%ce%b1-%ce%ad%ce%bd%cf%84%cf%85%cf%80%ce%b1-%ce%b3%ce%b9%ce%b1-%cf%86%ce%bf%ce%b9%cf%84%ce%b7%cf%84%ce%ad%cf%82/"        
        >Πρότυπο Συγγραφής Διπλωματικών</a>
        <br />
        <br />
        <a href="https://www.iee.ihu.gr/ects160/" target="_blank">Έλεγχος ΔΜ</a>

        <br />
        <br />
        <a
          href="/files/ΔΗΛΩΣΗ ΕΓΚΡΙΣΗΣ ΗΛΕΚΤΡΟΝΙΚΗΣ ΔΗΜΟΣΙΕΥΣΗΣ - ΔΙΠΛΩΜΑΤΙΚΗΣ.pdf"
          target="_blank"
        >Δήλωση Έγκρισης Ηλεκτρονικής Δημοσίευσης - Διπλωματικής</a>
        <br /><br />

        <a
          v-if="isProfessor || isAdmin"
          href="/files/Βαθμολόγιο ΔΕ_ΠΕ.pdf"
          target="_blank"
        >Βαθμολόγιο</a>
        <br /><br />
        <a
          href="/files/Σύντομος Οδηγός ΔΕ_ΠΕ.pdf"
          target="_blank"
        >{{this.Translate("@_MANUAL")}}</a>
      </div>
    </div>

    <div class="card">
      <div class="card-body text-center">
        <h5 class="card-title" v-html="'Στατιστικά Στοιχεία'"></h5>
      </div>

      <div>
        <span class="card-title" v-html="'Διαθέσιμες Πτυχιακές: '"></span>
        <span class="card-title" v-html="thesesStat.available_theses_pe"></span>
      </div>
      <div>
        <span class="card-title" v-html="'Διαθέσιμες Διπλωματικές: '"></span>
        <span class="card-title" v-html="thesesStat.available_theses_de"></span>
      </div>
      <br />
      <div>
        <span class="card-title" v-html="'Σε Ανάληψη Πτυχιακές: '"></span>
        <span class="card-title" v-html="thesesStat.taken_theses_pe"></span>
      </div>
      <div>
        <span class="card-title" v-html="'Σε Ανάληψη Διπλωματικές: '"></span>
        <span class="card-title" v-html="thesesStat.taken_theses_de"></span>
      </div>
      <br />
      <div>
        <span class="card-title" v-html="'Ολοκληρωμένες Πτυχιακές: '"></span>
        <span class="card-title" v-html="thesesStat.completed_theses_pe"></span>
      </div>
      <div>
        <span class="card-title" v-html="'Ολοκληρωμένες Διπλωματικές: '"></span>
        <span class="card-title" v-html="thesesStat.completed_theses_de"></span>
      </div>
      <br />
    </div>

    <div class="card">
      <div class="card-body text-center">
        <h5 class="card-title" v-html="'ΔΙΑΘΕΣΙΜΕΣ ΠΤΥΧΙΑΚΕΣ/ΔΙΠΛΩΜΑΤΙΚΕΣ'"></h5>
      </div>
      <table class="table table-striped table-bordered table-responsive border-0 mb-0">
        <thead>
          <tr>
            <th width="100%" class="text-center">Επιβλέπων</th>
            <th width="40%" class="text-center">Ποσότητα</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(result, index) in thesesStat.available_theses_byteacher" v-bind:key="index">
            <td v-html="result.name"></td>
            <td v-html="result.count"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="card">
      <div class="card-body text-center">
        <h5 class="card-title" v-html="'ΜΟΝΟ ΣΕ ΑΝΑΛΗΨΗ ΠΤΥΧΙΑΚΕΣ/ΔΙΠΛΩΜΑΤΙΚΕΣ'"></h5>
      </div>
      <table class="table table-striped table-bordered table-responsive border-0 mb-0">
        <thead>
          <tr>
            <th width="100%" class="text-center">Επιβλέπων</th>
            <th width="40%" class="text-center">Ποσότητα</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(result, index) in thesesStat.taken_theses_byteacher" v-bind:key="index">
            <td v-html="result.name"></td>
            <td v-html="result.count"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="card">
      <div class="card-body text-center">
        <h5 class="card-title" v-html="'ΟΛΟΚΛΗΡΩΜΕΝΕΣ ΠΤΥΧΙΑΚΕΣ/ΔΙΠΛΩΜΑΤΙΚΕΣ'"></h5>
      </div>
      <table class="table table-striped table-bordered table-responsive border-0 mb-0">
        <thead>
          <tr>
            <th width="100%" class="text-center">Επιβλέπων</th>
            <th width="40%" class="text-center">Ποσότητα</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(result, index) in thesesStat.completed_theses_byteacher"
            v-bind:key="index"
          >
            <td v-html="result.name"></td>
            <td v-html="result.count"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="card">
      <div class="card-body text-center">
        <h5 class="card-title" v-html="'ΟΛΕΣ ΟΙ ΠΤΥΧΙΑΚΕΣ/ΔΙΠΛΩΜΑΤΙΚΕΣ'"></h5>
      </div>
      <table class="table table-striped table-bordered table-responsive border-0 mb-0">
        <thead>
          <tr>
            <th width="100%" class="text-center">Επιβλέπων</th>
            <th width="40%" class="text-center">Ποσότητα</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(result, index) in thesesStat.all_theses_byteacher" v-bind:key="index">
            <td v-html="result.name"></td>
            <td v-html="result.count"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
  name: "Dashboard",
  mixins: [Mixin],
  data() {
    return {
      thesesStat: []
    };
  },
  methods: {
    getStats() {
      this.$store
        .dispatch("http_get_stats", {})
        .then(resp => {
          //console.log(resp);
          this.thesesStat = resp;
        })
        .catch(e => {
          console.error(e);
        });
    }
  },
  created() {
    this.getStats();
  }
};
</script>

<style scoped></style>
